
import './App.css';
import Weather from "./Weather"; 

export default function App() {
  return (
    <div className="App">
<Weather defaultCity="New York"/>
<footer>This app was coded by <a href="https://aquamarine-lollipop-4f3091.netlify.app/" target="_blank" rel="noopener noreferrer">Tiffany Anglero</a> and it is
< a href="https://github.com/tanglero4/react-weather-app-homework" target="_blank" rel="noopener noreferrer"> open-sourced on GitHub.</a>
</footer>
  </div>
  );
}


